import {
	getUserInfo
} from "@/api/oauth/index"

const state = {
	menuList: [],
	userInfo: {},
	permissionList: [],
}

const mutations = {
	SET_MENULIST: (state, menuList) => {
		state.menuList = menuList
	},
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo
	},
	SET_PERMISSION_LIST: (state, permissionList) => {
		state.permissionList = permissionList
	}
}

const actions = {
  // 获取用户信息
  getCurrentUser({commit}) {
  	return new Promise((resolve, reject) => {
  		getUserInfo().then(response => {
  			const {
  				data
  			} = response
  			if (!data) reject('验证失败，请重新登录。')
  			let {
  				isWeakPwd,
  				menuList,
  				userInfo,
  				permissionList,
          authCodeList
  			} = data
  			if (!menuList.length) {
  				reject('您的权限不足，请联系管理员')
  				return false;
  			}
  			commit('SET_MENULIST', menuList)
  			commit('SET_USERINFO', userInfo)
  			commit('SET_PERMISSION_LIST', authCodeList)
        resolve()
  		}).catch(error => {
  			reject(error)
  		})
  	})
  }
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}